import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BASE_LANGUAGE, LANGUAGE_LABELS } from '../../../../utils/constants/marketLanguages';

// languageOptions (voliteľné) - ak je zadané, pred tlačidlom sa zobrazí výber jazyka dokumentu
// (napr. EÚ vyhlásenie); ak nie, tlačidlo funguje ako predtým (napr. technická dokumentácia,
// ktorá je vždy len po slovensky).
// requireStandardsAssessment (voliteľné) - technická dokumentácia navyše vyžaduje vyplnenú sekciu d)
// Zoznam noriem a špecifikácií (viď standardsAssessmentSection.js), inak by bola neúplná (čl. 40 ods. 1 písm. d)).
const GenerateDocumentButton = ({ unit, label, generatingLabel, generateAction, languageOptions, requireStandardsAssessment }) => {
    const dispatch = useDispatch();
    const [generating, setGenerating] = useState(false);
    const [lang, setLang] = useState(BASE_LANGUAGE);

    const isConformityComplete = !!unit.conformitySummary?.complete;
    const isStandardsComplete = !requireStandardsAssessment || !!unit.standardsAssessmentSummary?.complete;
    const isComplete = isConformityComplete && isStandardsComplete;

    const handleGenerate = () => {
        setGenerating(true);
        dispatch(generateAction({ packagingUnitId: unit._id, name: unit.name, ...(languageOptions ? { lang } : {}) }))
            .unwrap()
            .catch(() => {})
            .finally(() => setGenerating(false));
    };

    const button = (
        <Button
            className="btn-custom-small"
            disabled={!isComplete || generating}
            onClick={handleGenerate}
        >
            {generating ? generatingLabel : label}
        </Button>
    );

    const languageSelect = languageOptions && languageOptions.length > 0 && (
        <Form.Select
            value={lang}
            onChange={e => setLang(e.target.value)}
            disabled={generating}
            title={LANGUAGE_LABELS[lang] ?? lang}
            style={{ width: 150, flex: '0 0 auto' }}
        >
            {languageOptions.map(code => (
                <option key={code} value={code}>
                    {code === BASE_LANGUAGE ? 'Slovenčina' : (LANGUAGE_LABELS[code] ?? code.toUpperCase())}
                </option>
            ))}
        </Form.Select>
    );

    if (isComplete) {
        return <div className="mb-3 d-flex gap-2">{languageSelect}{button}</div>;
    }

    const tooltipText = !isConformityComplete
        ? 'Dostupné až po splnení posúdenia zhody (záložka „Posúdenie zhody").'
        : 'Dostupné až po vyplnení sekcie d) Zoznam noriem a špecifikácií nižšie.';

    return (
        <div className="mb-3 d-flex gap-2">
            {languageSelect}
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{tooltipText}</Tooltip>}
            >
                <span className="d-inline-block">{button}</span>
            </OverlayTrigger>
        </div>
    );
};

export default GenerateDocumentButton;
